export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/fyi/graphql`
